// extracted by mini-css-extract-plugin
module.exports = {"header":"style__header__DfYRK","title":"style__title__aMpgd","pageNumber":"style__pageNumber__s1SN3"};